import { APIService } from "../../../../network/api/APIService";

export const  ArticlesData = ({ pageFilters, appId }) =>{
    let baseEndpoint = `/app/articles/?app_id=${appId}`;

    const filtersQuery = Object.entries(pageFilters)
        .filter(([_, value]) => value !== null && value !== "")
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");

    const endpoint = `${baseEndpoint}${filtersQuery ? `&${filtersQuery}` : ""}`;

    const config = {
        endpoint: endpoint,
        method: "GET",
        credentials: "include",
    };

    return APIService(config);
}